import axios from 'axios'
import { get } from 'svelte/store'
import { server_path, user, pro_monthly_sale_details, pro_yearly_sale_details, pro_monthly_price_details, pro_yearly_price_details, currency_sale, business_monthly_price_details, business_yearly_price_details, business_monthly_sale_details, business_yearly_sale_details } from '../stores'
import { getVisitorCountryCode } from '../modules/visitorCountry'
import queryString from 'query-string'

export const getSubscriptionPrices = async () => {
  const country_code = getVisitorCountryCode()

  const pro_yearly_product_id = 'wordmark-pro-12-subscription'
  const pro_monthly_product_id = 'wordmark-pro-monthly-subscription'
  const business_yearly_product_id = 'wordmark-business-12-subscription'
  const business_monthly_product_id = 'wordmark-business-monthly-subscription'
  
  const response_1 = await getProductLocalSubscriptionPrice(pro_yearly_product_id, country_code)
  const price_info_1 = response_1.data.products[0].pricing[country_code]
  
  console.log('Plans - received subscription price details for', pro_yearly_product_id, price_info_1)
  pro_yearly_price_details.set(price_info_1)

  if (!!price_info_1.quantityDiscount) {
    pro_yearly_sale_details.set(price_info_1.quantityDiscount[1])
  }

  // set currency sale if exists
  const currency = price_info_1.currency || "USD"
  const discounted_currencies = ["CAD", "CZK", "PLN", "RUB", "JPY", "CNY", "INR", "BRL"]
  currency_sale.set(discounted_currencies.includes(currency))

  const response_2 = await getProductLocalSubscriptionPrice(pro_monthly_product_id, country_code)
  const price_info_2 = response_2.data.products[0].pricing[country_code]

  console.log('Plans - received subscription price details for', pro_monthly_product_id, price_info_2)
  pro_monthly_price_details.set(price_info_2)
  
  if (!!price_info_2.quantityDiscount) {
    pro_monthly_sale_details.set(price_info_2.quantityDiscount[1])
  }

  // Get business subscription prices
  const business_yearly_response = await getProductLocalSubscriptionPrice(business_yearly_product_id, country_code)
  const business_yearly_price_info = business_yearly_response.data.products[0].pricing[country_code]
  console.log('Plans - received subscription price details for', business_yearly_product_id, business_yearly_price_info)
  business_yearly_price_details.set(business_yearly_price_info)
  
  if (!!business_yearly_price_info.quantityDiscount) {
    business_yearly_sale_details.set(business_yearly_price_info.quantityDiscount[1])
  }
  
  const business_monthly_response = await getProductLocalSubscriptionPrice(business_monthly_product_id, country_code)
  const business_monthly_price_info = business_monthly_response.data.products[0].pricing[country_code]
  console.log('Plans - received subscription price details for', business_monthly_product_id, business_monthly_price_info)
  business_monthly_price_details.set(business_monthly_price_info)
  
  if (!!business_monthly_price_info.quantityDiscount) {
    business_monthly_sale_details.set(business_monthly_price_info.quantityDiscount[1])
  }

  applyPromoFromQueryString()
}

export function getProductLocalSubscriptionPrice(product_id, country_code) {
  console.log('Plans - getting subscription price for', product_id, country_code)
  return axios.get(get(server_path) + 'fastspring/get_product_local_subscription_price.php?product_id=' + product_id + '&country_code=' + country_code, { withCredentials: true })
}

export function getSubscriptionChangeEstimate(subscription_id, product, prorate = true  ) {
  if (!subscription_id) {
    console.error('Subscriptions - No subscription ID provided for change estimate')
    return Promise.resolve({ data: null })
  }
  console.log('Subscriptions - Getting change estimate for', subscription_id, product)
  return axios.get(get(server_path) + 'fastspring/get_subscription_change_estimate.php?s_id=' + subscription_id + '&product=' + product + '&prorate=' + prorate, { withCredentials: true })
    .catch(error => {
      console.error('Error fetching subscription change estimate:', error)
      return { data: null }
    })
}

export function updateSubscription(subscription_id, product) {
  if (!subscription_id) {
    console.error('Subscriptions - No subscription ID provided for update')
    return Promise.reject(new Error('No subscription ID provided'))
  }
  console.log('Subscriptions - Updating subscription', subscription_id, 'to product', product)
  return axios.get(get(server_path) + 'fastspring/change_subscription_plan.php?s_id=' + subscription_id + '&product=' + product, { withCredentials: true })
    .catch(error => {
      console.error('Error updating subscription:', error)
      throw error
    })
}

function applyPromoFromQueryString() {
  let qs = queryString.parse(window.location.search)
  if (qs.promo_code && typeof window.fastspring !== "undefined") {
    fastspring.builder.promo(qs.promo_code)
    console.log('Plans - Applied promo code: ', qs.promo_code)
  }
}
